import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Button,
  
} from 'reactstrap';

import "./index.css";


const TermsPage = () => {

  return (
    <div className="bg-grey py-3 mt-8">
      <Container fluid>
        <Row>
          <Col lg="12" xl="12">
            <div className="text-center text-white mb-4">
              <h1 className="display-4 font-weight-bold">Fred S. Keller Store App Software License Agreement</h1>
              <h3 className="lead">Please read this agreement carefully</h3>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className="mt-4" fluid>
        <Row className="justify-content-center align-items-start">
          <Col lg="8" xl="8">
            <Card className="shadow-sm terms-card">
              <CardBody className="p-4">

                <section className="mb-4">
                  <h2 className="h5 mb-3">1. Definitions</h2>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2"><strong>Agreement:</strong> This End-User Software License Agreement.</li>
                    <li className="mb-2"><strong>App:</strong> Our educational applications, including the <strong>ELCAR</strong> and <strong>Listen First</strong> apps.</li>
                    <li className="mb-2"><strong>Content Files:</strong> Sample materials included with our apps.</li>
                    <li className="mb-2"><strong>Customer:</strong> You, or the organization you represent, that purchases a license.</li>
                    <li className="mb-2"><strong>Documentation:</strong> All written materials, files, and instructions for the software.</li>
                    <li className="mb-2"><strong>Fred S. Keller Store:</strong> The Fred S. Keller Store, a U.S. company.</li>
                    <li className="mb-2"><strong>License:</strong> The non-exclusive right to use the App as described in this Agreement.</li>
                    <li className="mb-2"><strong>Permitted Number:</strong> The number of devices you can install the App on, which is one (1), unless otherwise specified in your license.</li>
                    <li className="mb-2"><strong>Output File:</strong> Any chart, graph, or data file generated by you using the App for a specific learner.</li>
                    <li className="mb-2"><strong>Updates:</strong> Modifications, upgrades, and additions to the App provided by us.</li>
                  </ul>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">2. License Grant and Restrictions</h2>
                  <h3 className="h6 mb-3">2.1 License Grant</h3>
                  <p>If you have an active license, we grant you a non-exclusive license to use the <strong>App</strong> on a compatible device.</p>

                  <h3 className="h6 mb-3">2.2 Installation and Use</h3>
                  <p>You may install and use the <strong>App</strong> on your devices as long as your license is active, up to the <strong>Permitted Number</strong>.</p>
                  
                  <h3 className="h6 mb-3">2.3 Use of Output Files</h3>
                  <p>You may copy and use <strong>Output Files</strong> only for the specific child or student they were generated for. You may not:</p>
                  <ul>
                    <li>Change or alter any <strong>Output File</strong>.</li>
                    <li>Use them to create content for other learners.</li>
                    <li>Distribute <strong>Output Files</strong> to others.</li>
                  </ul>

                  <h3 className="h6 mb-3">2.4 Content Files</h3>
                  <p>You may not modify or share <strong>Content Files</strong> except as permitted in their "Read-Me" files. You cannot use them to create material that is illegal or violates the intellectual property rights of others.</p>
              
                  <h3 className="h6 mb-3">2.5 Pricing</h3>
                  <p>We can change our prices for licenses, renewals, or services at any time. Price changes won't affect the duration or features of licenses you've already purchased.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">3. Intellectual Property</h2>
                  <p>The <strong>App</strong> and any copies you make are the intellectual property of the <strong>Fred S. Keller Store</strong>. The software is protected by U.S. copyright laws. This Agreement gives you the right to use the <strong>App</strong>, but it does not give you ownership of it or its intellectual property.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">4. Feedback</h2>
                  <p>If you send us suggestions or feedback (<strong>"Feedback"</strong>) about the <strong>App</strong>, we can use it for any purpose without paying you or giving you credit. You agree to transfer all rights to this Feedback to the <strong>Fred S. Keller Store</strong>.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">5. Copying and Transfer Restrictions</h2>
                  <h3 className="h6 mb-3">5.1 Copying</h3>
                  <p>Any copy of the <strong>App</strong> you make must include the same copyright notices as the original.</p>
              
                  <h3 className="h6 mb-3">5.2 No Modifications</h3>
                  <p>You may not modify, adapt, or translate the <strong>App</strong>.</p>
              
                  <h3 className="h6 mb-3">5.3 No Reverse Engineering</h3>
                  <p>You may not reverse engineer, decompile, or disassemble the <strong>App</strong> to discover its source code.</p>
              
                  <h3 className="h6 mb-3">5.4 Component Integrity</h3>
                  <p>The <strong>App</strong> is a single product. You may not separate its parts for use on different devices or for distribution.</p>
              
                  <h3 className="h6 mb-3">5.5 No Transfer</h3>
                  <p>You may not rent, lease, sell, or transfer your license to anyone else.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">6. Updates and Upgrades</h2>
                  <p>We may release <strong>Updates</strong> to the <strong>App</strong>. We may require you to install these Updates to continue using the <strong>App</strong>.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">7. Limited Warranty</h2>
                  <h3 className="h6 mb-3">7.1 Performance Warranty</h3>
                  <p>For 90 days after you receive the <strong>App</strong>, we guarantee that it will perform as described in the <strong>Documentation</strong> if used on a compatible device.</p>

                  <h3 className="h6 mb-3">7.2 Warranty Exclusions</h3>
                  <p>This warranty does not apply to free, trial, or beta versions of the <strong>App</strong>.</p>

                  <h3 className="h6 mb-3">7.3 Exclusive Remedy</h3>
                  <p>If the <strong>App</strong> doesn't perform as described, your only option is for us to either replace the <strong>App</strong> or refund your license fee.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">8. Warranty Disclaimer and Liability Limitation</h2>
                  <h3 className="h6 mb-3">8.1 Warranty Disclaimer</h3>
                  <p>The limited warranty in Section 7 is the only warranty we provide. The <strong>App</strong> is provided <strong>"AS IS"</strong> and <strong>"WITH ALL FAULTS,"</strong> and we disclaim all other warranties, including merchantability, non-infringement, and fitness for a particular purpose.</p>

                  <h3 className="h6 mb-3">8.2 Liability Limitation</h3>
                  <p>We will not be liable for any damages, including lost profits, business interruption, or personal injury, even if we've been advised of the possibility of such damages. Our total liability under this Agreement is limited to the amount you paid for the <strong>App</strong>.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">9. Governing Law</h2>
                  <p>This Agreement is governed by the laws of the Commonwealth of Pennsylvania, without regard to its conflict of law principles. Any legal action related to this Agreement must be brought in the state or federal courts of Luzerne County, Pennsylvania.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">10. Termination</h2>
                  <p>We may terminate this Agreement if you violate its terms. Upon termination, your license ends, and you must stop using and destroy all copies of the <strong>App</strong>.</p>
                </section>
                <hr className="my-4" />

                <section className="mb-4">
                  <h2 className="h5 mb-3">11. Contact Information</h2>
                  <p>For questions, please contact us at the address provided with the product.</p>
                </section>

                <div className="text-center text-muted mt-5 pt-4 border-top">
                  <small>ELCAR™, Listen First™, and Fred S. Keller Store™ are trademarks of the Fred S. Keller Store.</small>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsPage;